// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__ESCtF","containerRedMark":"Notification_containerRedMark__ITPs4"};